import { consumeIdentityLanding, createSiteLineIdentityClient } from './lib/managed-identity-client';
import { appRoot } from './app-root';
import LaunchScreen from './lib/LaunchScreen';
import './product/styles/globals.css';
import './styles.css';
// Strip one-use callback material before importing Firebase, the product or telemetry.
const managed = import.meta.env.VITE_IDENTITY_GCP_ENABLED === 'true';
const guestVisit = window.location.pathname === '/video-join';
const guestInvite = guestVisit ? new URLSearchParams(window.location.hash.slice(1)).get('invite') || '' : '';
if (guestVisit) window.history.replaceState(null, '', '/video-join');
const landing = managed && !guestVisit ? consumeIdentityLanding(window.location, window.history) : null;
appRoot.render(<LaunchScreen />);
async function start() {
  if (guestVisit) {
    const { SiteVideoGuest } = await import('./lib/SiteVideoGuest');
    appRoot.render(<SiteVideoGuest invite={guestInvite} />);
    return;
  }
  if (landing) {
    const client = createSiteLineIdentityClient();
    try {
      if (landing.kind === 'invalid') throw new Error('Invalid sign-in handoff');
      if (landing.kind === 'start') {
        window.location.assign(await client.begin(landing.tenantId, landing.branchId)); return;
      }
      await client.complete(landing.code, landing.requestId);
      window.history.replaceState(null, '', '/');
    } catch {
      const { showHandoffError } = await import('./lib/ManagedHandoffError');
      showHandoffError(); return;
    }
  }
  await import('./app-bootstrap');
}
void start();
